import { render } from "./QueenMarkerIcon.vue?vue&type=template&id=0e27f8fc&ts=true"
import script from "./QueenMarkerIcon.vue?vue&type=script&lang=ts"
export * from "./QueenMarkerIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__